
import {
  FETCH_DEVICES,
  SET_DEVICES,
  SET_DEVICES_FAILURE,
  CLEAR_DEVICES,
  FETCH_DEVICE_DETAILS,
  SET_DEVICE_DETAILS,
  SET_DEVICE_DETAILS_FAILURE,
  CLEAR_DEVICE_DETAILS,
  UPDATE_DEVICE_STATUS,
  SET_DEVICE_STATUS_SUCCESS,
  SET_DEVICE_STATUS_FAILURE,
  UPDATE_DEVICE_PROJECT,
  SET_DEVICE_PROJECT_SUCCESS,
  SET_DEVICE_PROJECT_FAILURE,
  BULK_UPDATE_DEVICES,
  SET_BULK_UPDATE_SUCCESS,
  SET_BULK_UPDATE_FAILURE,
  FETCH_DEVICE_FILTERS,
  SET_DEVICE_FILTERS,
  SET_DEVICE_FILTERS_FAILURE,
  FETCH_DEVICE_STATS,
  SET_DEVICE_STATS,
  SET_DEVICE_STATS_FAILURE,
  DEVICE_REBOOT,
  SET_DEVICE_REBOOT_SUCCESS,
  SET_DEVICE_REBOOT_FAILURE,
  DEVICE_FIRMWARE_UPDATE,
  SET_DEVICE_FIRMWARE_UPDATE_SUCCESS,
  SET_DEVICE_FIRMWARE_UPDATE_FAILURE,
  FETCH_PROJECT_LIST,
  SET_PROJECT_LIST,
  SET_PROJECT_LIST_FAILURE,
  FETCH_DEVICE_PROJECT_LIST,
  SET_DEVICE_PROJECT_LIST,
  SET_DEVICE_PROJECT_LIST_FAILURE,
  FETCH_DEVICE_LOGS,
  SET_DEVICE_LOGS,
  SET_DEVICE_LOGS_FAILURE,
  CLEAR_DEVICE_LOGS,
  // Communication Check Actions
  CHECK_COMMUNICATION,
  SET_COMMUNICATION_SUCCESS,
  SET_COMMUNICATION_FAILURE,
  SET_COMMUNICATION_RESPONSE_TIME,
  START_COMMUNICATION_TIMER,
  // Get All Devices Actions
  GET_ALL_DEVICES,
  SET_ALL_DEVICES_SUCCESS,
  SET_ALL_DEVICES_FAILURE,
  // Device Time Management Actions
  SET_DEVICE_TIME_DETAILS,
  GET_DEVICE_TIME_DETAILS,
  SET_DEVICE_TIME_SUCCESS,
  SET_DEVICE_TIME_FAILURE,
  SET_DEVICE_TIME_SET_SUCCESS,
  SET_DEVICE_TIME_SET_FAILURE,
  // Device Logs Management Actions
  CHECK_NUMBER_LOGS,
  ERASE_LOGS,
  SET_LOGS_SUCCESS,
  SET_LOGS_FAILURE,
  SET_ERASE_LOGS_SUCCESS,
  SET_ERASE_LOGS_FAILURE,
  // Weld Parameters Actions
  WELDPARAMS,
  LOCATION,
  PASSWORD_PROTECTION,
  SET_WELD_PARAMS_SUCCESS,
  SET_WELD_PARAMS_FAILURE,
  SET_LOCATION_SUCCESS,
  SET_LOCATION_FAILURE,
  // Device Status Update Actions
  UPDATE_DEVICE_OPERATION_STATUS,
  SET_DEVICE_OPERATION_STATUS_SUCCESS,
  SET_DEVICE_OPERATION_STATUS_FAILURE,
  // Communication Polling Actions
  START_COMMUNICATION_POLLING,
  STOP_COMMUNICATION_POLLING,
  POLL_COMMUNICATION_STATUS,
  SET_POLLING_STATUS,
  UPDATE_POLLING_PROGRESS,
  // Clear Operations Data
  CLEAR_DEVICE_OPERATIONS_DATA,
  // Rename Pass Actions
  RENAME_PASS,
  SET_RENAME_PASS_SUCCESS,
  SET_RENAME_PASS_FAILURE,
  // Firmware Update Device Tracking
  ADD_FIRMWARE_UPDATE_DEVICE,
  REMOVE_FIRMWARE_UPDATE_DEVICE,
  CLEAR_FIRMWARE_UPDATE_DEVICES,
  // Firmware Update Polling
  START_FIRMWARE_UPDATE_POLLING,
  STOP_FIRMWARE_UPDATE_POLLING,
  UPDATE_FIRMWARE_UPDATE_PROGRESS,
  SET_FIRMWARE_UPDATE_PROGRESS,
  CLEAR_FIRMWARE_UPDATE_PROGRESS
} from './types';

// Action creators for Device List
export const fetchDevices = (payload) => ({
  type: FETCH_DEVICES,
  payload
});

export const setDevices = (devices) => ({
  type: SET_DEVICES,
  devices
});

export const setDevicesFailure = (error) => ({
  type: SET_DEVICES_FAILURE,
  error
});

export const clearDevices = () => ({
  type: CLEAR_DEVICES
});

// Action creators for Device Details
export const fetchDeviceDetails = (payload) => ({
  type: FETCH_DEVICE_DETAILS,
  payload
});

export const setDeviceDetails = (deviceDetails) => ({
  type: SET_DEVICE_DETAILS,
  deviceDetails
});

export const setDeviceDetailsFailure = (error) => ({
  type: SET_DEVICE_DETAILS_FAILURE,
  error
});

export const clearDeviceDetails = () => ({
  type: CLEAR_DEVICE_DETAILS
});

// Action creators for Device Status Update
export const updateDeviceStatus = (payload) => ({
  type: UPDATE_DEVICE_STATUS,
  payload
});

export const setDeviceStatusSuccess = (deviceId, status) => ({
  type: SET_DEVICE_STATUS_SUCCESS,
  deviceId,
  status
});

export const setDeviceStatusFailure = (error) => ({
  type: SET_DEVICE_STATUS_FAILURE,
  error
});

// Action creators for Device Project Assignment
export const updateDeviceProject = (payload) => ({
  type: UPDATE_DEVICE_PROJECT,
  payload
});

export const setDeviceProjectSuccess = (deviceId, project) => ({
  type: SET_DEVICE_PROJECT_SUCCESS,
  deviceId,
  project
});

export const setDeviceProjectFailure = (error) => ({
  type: SET_DEVICE_PROJECT_FAILURE,
  error
});

// Action creators for Bulk Device Updates
export const bulkUpdateDevices = (payload) => ({
  type: BULK_UPDATE_DEVICES,
  payload
});

export const setBulkUpdateSuccess = (updatedDevices) => ({
  type: SET_BULK_UPDATE_SUCCESS,
  updatedDevices
});

export const setBulkUpdateFailure = (error) => ({
  type: SET_BULK_UPDATE_FAILURE,
  error
});

// Action creators for Device Filters
export const fetchDeviceFilters = (payload) => ({
  type: FETCH_DEVICE_FILTERS,
  payload
});

export const setDeviceFilters = (filters) => ({
  type: SET_DEVICE_FILTERS,
  filters
});

export const setDeviceFiltersFailure = (error) => ({
  type: SET_DEVICE_FILTERS_FAILURE,
  error
});

// Action creators for Device Stats
export const fetchDeviceStats = (payload) => ({
  type: FETCH_DEVICE_STATS,
  payload
});

export const setDeviceStats = (stats) => ({
  type: SET_DEVICE_STATS,
  stats
});

export const setDeviceStatsFailure = (error) => ({
  type: SET_DEVICE_STATS_FAILURE,
  error
});

// Action creators for Device Reboot
export const deviceReboot = (payload) => ({
  type: DEVICE_REBOOT,
  payload
});

export const setDeviceRebootSuccess = (deviceId) => ({
  type: SET_DEVICE_REBOOT_SUCCESS,
  deviceId
});

export const setDeviceRebootFailure = (error) => ({
  type: SET_DEVICE_REBOOT_FAILURE,
  error
});

// Action creators for Device Firmware Update
export const deviceFirmwareUpdate = (payload) => ({
  type: DEVICE_FIRMWARE_UPDATE,
  payload
});

export const setDeviceFirmwareUpdateSuccess = (deviceId, firmwareVersion) => ({
  type: SET_DEVICE_FIRMWARE_UPDATE_SUCCESS,
  deviceId,
  firmwareVersion
});

export const setDeviceFirmwareUpdateFailure = (error) => ({
  type: SET_DEVICE_FIRMWARE_UPDATE_FAILURE,
  error
});

// Action creators for Firmware Update Device Tracking
export const addFirmwareUpdateDevice = (deviceId) => ({
  type: ADD_FIRMWARE_UPDATE_DEVICE,
  deviceId
});

export const removeFirmwareUpdateDevice = (deviceId) => ({
  type: REMOVE_FIRMWARE_UPDATE_DEVICE,
  deviceId
});

export const clearFirmwareUpdateDevices = () => ({
  type: CLEAR_FIRMWARE_UPDATE_DEVICES
});

// Action creators for Device Logs
export const fetchDeviceLogs = (payload) => ({
  type: FETCH_DEVICE_LOGS,
  payload
});

export const setDeviceLogs = (deviceId, logs) => ({
  type: SET_DEVICE_LOGS,
  deviceId,
  logs
});

export const setDeviceLogsFailure = (error) => ({
  type: SET_DEVICE_LOGS_FAILURE,
  error
});

export const clearDeviceLogs = () => ({
  type: CLEAR_DEVICE_LOGS
});

// Clear all device operations data
export const clearDeviceOperationsData = () => ({
  type: CLEAR_DEVICE_OPERATIONS_DATA
});

// Action creators for Communication Check
export const checkCommunication = (payload) => ({
  type: CHECK_COMMUNICATION,
  payload
});

export const setCommunicationSuccess = (deviceId, communicationData) => ({
  type: SET_COMMUNICATION_SUCCESS,
  deviceId,
  communicationData
});

export const setCommunicationResponseTime = (deviceId, responseTime) => ({
  type: SET_COMMUNICATION_RESPONSE_TIME,
  deviceId,
  responseTime
});

export const startCommunicationTimer = (deviceId) => ({
  type: START_COMMUNICATION_TIMER,
  deviceId,
  startTime: Date.now()
});

export const setCommunicationFailure = (error) => ({
  type: SET_COMMUNICATION_FAILURE,
  error
});

// Get All Devices Actions
export const getAllDevices = (payload) => ({
  type: GET_ALL_DEVICES,
  payload
});

export const setAllDevicesSuccess = (deviceId, data) => ({
  type: SET_ALL_DEVICES_SUCCESS,
  deviceId,
  data
});

export const setAllDevicesFailure = (error) => ({
  type: SET_ALL_DEVICES_FAILURE,
  error
});

// Action creators for Device Time Management
export const setDeviceTimeDetails = (payload) => ({
  type: SET_DEVICE_TIME_DETAILS,
  payload
});

export const getDeviceTimeDetails = (payload) => ({
  type: GET_DEVICE_TIME_DETAILS,
  payload
});

export const setDeviceTimeSuccess = (deviceId, timeData) => ({
  type: SET_DEVICE_TIME_SUCCESS,
  deviceId,
  timeData
});

export const setDeviceTimeFailure = (error) => ({
  type: SET_DEVICE_TIME_FAILURE,
  error
});

// Separate actions for Set Time operations
export const setDeviceTimeSetSuccess = (deviceId, timeData) => ({
  type: SET_DEVICE_TIME_SET_SUCCESS,
  deviceId,
  timeData
});

export const setDeviceTimeSetFailure = (error) => ({
  type: SET_DEVICE_TIME_SET_FAILURE,
  error
});

// Action creators for Device Logs Management
export const checkNumberLogs = (payload) => ({
  type: CHECK_NUMBER_LOGS,
  payload
});

export const eraseLogs = (payload) => ({
  type: ERASE_LOGS,
  payload
});

export const setLogsSuccess = (deviceId, logsData) => ({
  type: SET_LOGS_SUCCESS,
  deviceId,
  logsData
});

export const setLogsFailure = (error) => ({
  type: SET_LOGS_FAILURE,
  error
});

// Separate actions for Erase Logs
export const setEraseLogsSuccess = (deviceId, eraseData) => ({
  type: SET_ERASE_LOGS_SUCCESS,
  deviceId,
  eraseData
});

export const setEraseLogsFailure = (error) => ({
  type: SET_ERASE_LOGS_FAILURE,
  error
});

// Action creators for Weld Parameters
export const weldParams = (payload) => ({
  type: WELDPARAMS,
  payload
});

export const location = (payload) => ({
  type: LOCATION,
  payload
});

export const passwordProtection = (payload) => ({
  type: PASSWORD_PROTECTION,
  payload
});

export const setWeldParamsSuccess = (deviceId, weldParamsData) => ({
  type: SET_WELD_PARAMS_SUCCESS,
  deviceId,
  weldParamsData
});

export const setWeldParamsFailure = (error) => ({
  type: SET_WELD_PARAMS_FAILURE,
  error
});

// Location Actions
export const setLocationSuccess = (deviceId, locationData) => ({
  type: SET_LOCATION_SUCCESS,
  deviceId,
  locationData
});

export const setLocationFailure = (error) => ({
  type: SET_LOCATION_FAILURE,
  error
});

// Action creators for Device Operation Status Update
export const updateDeviceOperationStatus = (payload) => ({
  type: UPDATE_DEVICE_OPERATION_STATUS,
  payload
});

export const setDeviceOperationStatusSuccess = (deviceId, operationStatus, lastUpdated) => ({
  type: SET_DEVICE_OPERATION_STATUS_SUCCESS,
  deviceId,
  operationStatus,
  lastUpdated
});

export const setDeviceOperationStatusFailure = (error) => ({
  type: SET_DEVICE_OPERATION_STATUS_FAILURE,
  error
});

// Action creators for Communication Polling
export const startCommunicationPolling = (payload) => ({
  type: START_COMMUNICATION_POLLING,
  payload
});

export const stopCommunicationPolling = (payload) => ({
  type: STOP_COMMUNICATION_POLLING,
  payload
});

export const pollCommunicationStatus = (payload) => ({
  type: POLL_COMMUNICATION_STATUS,
  payload
});

export const setPollingStatus = (payload) => ({
  type: SET_POLLING_STATUS,
  payload
});

export const updatePollingProgress = (payload) => ({
  type: UPDATE_POLLING_PROGRESS,
  payload
});

// Action creators for Project List
export const fetchProjectList = (payload) => ({
  type: FETCH_PROJECT_LIST,
  payload
});

export const setProjectList = (projectList) => ({
  type: SET_PROJECT_LIST,
  projectList
});

export const setProjectListFailure = (error) => ({
  type: SET_PROJECT_LIST_FAILURE,
  error
});

export const fetchDeviceProjectList = (payload) => ({
  type: FETCH_DEVICE_PROJECT_LIST,
  payload
});

export const setDeviceProjectList = (projectList) => ({
  type: SET_DEVICE_PROJECT_LIST,
  projectList
});

export const setDeviceProjectListFailure = (error) => ({
  type: SET_DEVICE_PROJECT_LIST_FAILURE,
  error
});

// Action creators for Rename Pass
export const renamePass = (payload) => ({
  type: RENAME_PASS,
  payload
});

export const setRenamePassSuccess = (deviceId, data) => ({
  type: SET_RENAME_PASS_SUCCESS,
  deviceId,
  data
});

export const setRenamePassFailure = (error) => ({
  type: SET_RENAME_PASS_FAILURE,
  error
});

// Action creators for Firmware Update Polling
export const startFirmwareUpdatePolling = (deviceId, deviceData) => ({
  type: START_FIRMWARE_UPDATE_POLLING,
  deviceId,
  deviceData
});

export const stopFirmwareUpdatePolling = (deviceId) => ({
  type: STOP_FIRMWARE_UPDATE_POLLING,
  deviceId
});

export const updateFirmwareUpdateProgress = (deviceId, progressData) => ({
  type: UPDATE_FIRMWARE_UPDATE_PROGRESS,
  deviceId,
  progressData
});

export const setFirmwareUpdateProgress = (deviceId, progressData) => ({
  type: SET_FIRMWARE_UPDATE_PROGRESS,
  deviceId,
  progressData
});

export const clearFirmwareUpdateProgress = (deviceId) => ({
  type: CLEAR_FIRMWARE_UPDATE_PROGRESS,
  deviceId
});
